import ReplacementContainer from '../primitives/grid/container'

/* max-w-6xl = maxWidth: 1152px */
const Container = ReplacementContainer;//;tw.div`max-w-6xl mx-auto px-4 xs:px-6 xl:px-0`

export default Container
